import LocalidadeService from '../../services/LocalidadeService'

// Remove caches de versões anteriores que salvavam a busca no navegador
;['dadosBusca', 'estados', 'municipios'].forEach(chave => localStorage.removeItem(chave))

const state = () => ({
  municipios: [],
  loadingMunicipios: false,
  cidadesPorUF: {},
  center: { lat: -16, lng: -58 },
  openedMarkerID: null
})

const mutations = {
    SET_MUNICIPIOS: (state, municipios) => {
      state.municipios = municipios;
    },
    SET_LOADING_MUNICIPIOS: (state, payload) => {
      state.loadingMunicipios = payload;
    },
    SET_CIDADES_UF: (state, { idUF, cidades }) => {
      state.cidadesPorUF = { ...state.cidadesPorUF, [idUF]: cidades };
    },
    SET_MAP_CENTER: (state, {lat, lng, id}) => {
      state.center = { lat, lng };
      state.openedMarkerID = id;
    },
    SET_OPEN_MARKER_ID: (state, id) => {
      state.openedMarkerID = id;
    },
}

const actions = {
  async carregarMunicipios({ commit, state }) {
    if (state.municipios.length || state.loadingMunicipios) return
    commit('SET_LOADING_MUNICIPIOS', true)
    try {
      const response = await LocalidadeService.getMunicipiosIBGE();
      const municipios = response.data
        .map(m => ({
          id: m['municipio-id'],
          nome: m['municipio-nome'],
          uf: m['UF-sigla'],
          idUF: m['UF-id']
        }))
        .sort((a, b) => a.nome.localeCompare(b.nome))
      commit('SET_MUNICIPIOS', municipios)
    } catch (error) {
      console.error('Erro ao carregar municípios do IBGE:', error);
    } finally {
      commit('SET_LOADING_MUNICIPIOS', false)
    }
  },
  // Resolve latitude/longitude de um município selecionado no autocomplete
  async buscarCoordenadasMunicipio({ commit, state }, municipio) {
    let cidades = state.cidadesPorUF[municipio.idUF]
    if (!cidades) {
      const response = await LocalidadeService.getCidades(municipio.idUF);
      cidades = response.data
      commit('SET_CIDADES_UF', { idUF: municipio.idUF, cidades })
    }
    return cidades.find(cidade => cidade.codigo_ibge === municipio.id) || null
  },
  // Cidade mais próxima das coordenadas do usuário (geolocalização)
  async buscarCidadeMaisProxima(_, { lat, lng }) {
    const response = await LocalidadeService.getNearbyCities(lat, lng);
    return response.data[0] || null
  },
}

const getters = {
  getMunicipios: state => state.municipios,
  getLoadingMunicipios: state => state.loadingMunicipios,
  getCenter: state => state.center,
  getOpenedMarkerID: state => state.openedMarkerID,
}

export default {
  state,
  getters,
  mutations,
  actions
};
